module.exports = __webpack_public_path__ + "static/media/emptyState.a3581579.svg";